import React from "react";
import { useTranslation } from "react-i18next";
import { IGetMyServiceListRes } from "src/service/types/console.type";

interface Props {
  items: IGetMyServiceListRes[];
  isOciProduct: boolean;
  productKey?: string;
  onClickItem?: (index: number) => void; // 클릭 시 viewType -> detail로 변경 (나중에 필요시 개발)
  getUrl: (svc: IGetMyServiceListRes) => string;
  dateFormatUtc: (n: number) => string;
}

const ServiceCards = ({ items, onClickItem, getUrl, dateFormatUtc }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap">
      {items?.map((item, index) => (
        <div key={item.serviceUid ?? index} className="flex-item box">
          {/* <form className="form" onClick={() => onClickItem(index)}> */}
          <form className="form">
            <div className="form-thumnail">
              {item.serviceName.substring(0, 2)}
            </div>
            <div className="form-name">
              <h4 className="form-name-title">{item.serviceName}</h4>
              <h4 className="form-name-url">{getUrl(item)}</h4>
            </div>
            <div className="form-info">
              <i className="icon_user inline-block vertical-middle" />
              <span className="inline-block vertical-middle mg ml-10">
                {item.licenseCount}
              </span>
              <i className="icon_clock inline-block vertical-middle mg ml-20" />
              <span className="inline-block vertical-middle mg ml-10">
                {Number(item.serviceEndTime) > 0
                  ? dateFormatUtc(Number(item.serviceEndTime))
                  : t(
                      "siteManagement.paymentHistory.paymentManagement.unlimited"
                    )}
              </span>
            </div>
          </form>
        </div>
      ))}
    </div>
  );
};

export default ServiceCards;
